module.exports = "/**\n * Applies styles for users in high contrast mode. Note that this only applies\n * to Microsoft browsers. Chrome can be included by checking for the `html[hc]`\n * attribute, however Chrome handles high contrast differently.\n */\n/* Theme for the ripple elements.*/\n/* stylelint-disable material/no-prefixes */\n/* stylelint-enable */\n.ok-button {\n  color: #FFF;\n  background-color: #75c2a4; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/remote/game/dialog-result-confirm/dialog-result-confirm.component.scss
// module id = ./src/app/remote/game/dialog-result-confirm/dialog-result-confirm.component.scss
// module chunks = main